import React from 'react';

class IntegrationsPageBuildStatus extends React.Component {
    render() {
        return (
            <React.Fragment>
            
                <div class="col-md-5 offset-md-1 col-lg-5">
                    <h5 class="text-muted fw-normal mt-2 mb-0 text-truncate" title="Campaign Sent">Status</h5>
                    <div id="bar" class="progress mt-2" style={{height: '7px'}}>
                        <div style={{width: '75%'}} class="bar progress-bar progress-bar-striped progress-bar-animated bg-success"></div>
                    </div>
                    <span class="form-text"><em>Building integration...</em></span>
                </div>

            </React.Fragment>
        );
    }
}

export default IntegrationsPageBuildStatus;
